import { UserPlus } from "lucide-react";
import { themeToCssVars } from "@/lib/theme/generateTheme";
import { Hero, SocialButtons, ContactActions, Panel, CompanyPanel, ContactPanel } from "@/features/profiles/components/publicProfileParts";
import "@/features/profiles/publicProfile.css";

// Pure presentation: used by the live /:slug page and the owner's editor preview.
export default function PublicProfileView({ identity, theme, onSaveContact }) {
  return (
    <div className="pp" style={themeToCssVars(theme)} data-testid="public-profile-view">
      <Hero identity={identity} />
      <div className="pp-body">
        <SocialButtons links={identity.links} />
        <ContactActions identity={identity} />
        {identity.bio && (
          <Panel title="About me" testId="pp-about">
            <p className="pp-text">{identity.bio}</p>
          </Panel>
        )}
        <CompanyPanel identity={identity} />
        <ContactPanel identity={identity} />
      </div>
      <div className="pp-savebar">
        <button type="button" onClick={onSaveContact} data-testid="save-contact-button" className="pp-save">
          <UserPlus className="h-5 w-5" aria-hidden="true" /> Save to contacts
        </button>
      </div>
    </div>
  );
}
